import React from 'react';
import { Award, Medal, Crown, Sparkles } from 'lucide-react';
import { useT } from '../services/i18n';

const TIERS = {
  bronze: { icon: Medal, ring: 'from-amber-700 to-orange-400', chip: 'bg-orange-100 text-orange-900 border-orange-300' },
  silver: { icon: Award, ring: 'from-slate-400 to-gray-200', chip: 'bg-slate-100 text-slate-800 border-slate-300' },
  gold: { icon: Crown, ring: 'from-yellow-500 to-amber-300', chip: 'bg-yellow-100 text-yellow-900 border-yellow-400' },
};

// Referral rank badge (Bronze ≥ 1 friend, Silver ≥ 3, Gold ≥ 10) with progress towards the next tier
export const ReferralBadge = ({ rank, testId = 'referral-badge' }) => {
  const { t } = useT();
  if (!rank) return null;
  const tier = rank.tier ? TIERS[rank.tier] : null;
  const Icon = tier ? tier.icon : Sparkles;
  return (
    <div className="bg-white rounded-xl shadow-sm p-4 flex items-center gap-4" data-testid={testId}>
      <div className={`shrink-0 w-14 h-14 rounded-full bg-gradient-to-br ${tier ? tier.ring : 'from-gray-200 to-gray-100'} p-[3px]`}>
        <div className="w-full h-full rounded-full bg-white flex items-center justify-center"><Icon size={26} className={tier ? 'text-gray-800' : 'text-gray-400'} /></div>
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full border ${tier ? tier.chip : 'bg-gray-100 text-gray-600 border-gray-200'}`} data-testid={`${testId}-tier`}>{t(rank.tier ? `share.tier_${rank.tier}` : 'share.tier_none')}</span>
          <span className="text-xs text-gray-500" data-testid={`${testId}-friends`}>{t('share.badgeFriends', { n: rank.friends })}</span>
        </div>
        {rank.next_tier ? (
          <>
            <div className="mt-2 h-2 rounded-full bg-gray-100 overflow-hidden"><div className={`h-full rounded-full bg-gradient-to-r ${TIERS[rank.next_tier].ring} transition-[width] duration-700`} style={{ width: `${Math.max(rank.progress, 4)}%` }} data-testid={`${testId}-progress`} /></div>
            <p className="text-xs text-gray-600 mt-1" data-testid={`${testId}-next`}>{t('share.badgeNext', { n: rank.missing, tier: t(`share.tier_${rank.next_tier}`) })}</p>
          </>
        ) : <p className="text-xs text-gray-600 mt-1" data-testid={`${testId}-max`}>{t('share.badgeMax')}</p>}
        <p className="text-[11px] text-gray-400 mt-1">{t('share.badgeLevels')}</p>
      </div>
    </div>
  );
};

export default ReferralBadge;
